import axios from 'axios'
import { host } from '../../../helper/config'
import { ITEM_PER_PAGE } from '../../../helper/helper'

const PLUGINS_NAME = 'admin-loto-reward'

export const getListReward = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-list`, {
        ...query,
        page: page,
        itemPerPage: ITEM_PER_PAGE
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const getSummaryReward = async (token, query) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-summary`, query, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const getListBigReward = async (token, query, page) => {
  const response = await axios.post(`${host}/${PLUGINS_NAME}/get-list-big-reward`, {
      ...query,
      page: page,
      itemPerPage: ITEM_PER_PAGE
  }, {
      headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'Authorization': token
      },
  })

  if (response && response.status === 200) {
      return response.data || {}
  }
  return null
}

export const getSummaryBigReward = async (token, query) => {
  const response = await axios.post(`${host}/${PLUGINS_NAME}/get-summary-big-reward`, {
      ...query,
  }, {
      headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'Authorization': token
      },
  })

  if (response && response.status === 200) {
      return response.data || {}
  }
  return null
}

export const submitBigReward = async (token, transId) => {
  const response = await axios.post(`${host}/${PLUGINS_NAME}/submit-big-reward`, {
    id: transId,
  }, {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'Authorization': token
    },
  })

  if (response && response.status === 200 && response.data.status === 1) {
      return true
  }
  return false
}

export const payReward = async (token, transId, userId, cartGroupId) => {
  const response = await axios.post(`${host}/${PLUGINS_NAME}/pay`, {
      transId: transId,
      userId: userId,
      cartGroupId: cartGroupId
  }, {
      headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'Authorization': token
      },
  })

  if (response && response.status === 200 && response.data == 'done') {
      return true
  }
  return false
}

export const payAllReward = async (token, gameId) => {
  const payload = gameId ? {
      gameId: gameId
  } : undefined
  const response = await axios.post(`${host}/${PLUGINS_NAME}/pay-all`, payload, {
      headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'Authorization': token
      },
  })

  if (response && response.status === 200) {
      const d = response.data
      if (d === 'done' || d?.status === 'done') {
          return {
              ok: true,
              enqueued: typeof d?.enqueued === 'number' ? d.enqueued : 0,
              totalNetAmount: typeof d?.totalNetAmount === 'string' ? d.totalNetAmount : '0',
          }
      }
  }
  return { ok: false, enqueued: 0, totalNetAmount: '0' }
}

export const getPayAllProgress = async (token, gameId) => {
  const response = await axios.post(`${host}/${PLUGINS_NAME}/pay-all-progress`, {
      gameId: gameId || null,
  }, {
      headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'Authorization': token
      },
  })

  if (response && response.status === 200) {
      return response.data || {}
  }
  return null
}
